import { Injectable, ModuleWithProviders, NgModule } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  IPermissions,
  IPolicies,
  PolicyPermissionsService,
} from 'services/policy-permission/policy-permissions.service';
import { take, withLatestFrom } from 'rxjs/operators';
import { Selectors as LabelSelectors } from 'features/global-organizations-setting-state/global-organizations-setting.state';
import { Selectors } from 'features/profiles-state/+state/profiles-state.state';
import { GlobalOrganizationsLabel } from 'features/global-organizations-setting-state/global-organizations-setting.constant';
import { ORGANIZATION_TYPE } from 'constants/constants';
import { ReplaySubject } from 'rxjs';

export type PROFESSIONAL_CARD_POLICIES_KEYS = 'organizationRolesFeatureFlag' | 'personalInfoEdit';

const PROFESSIONAL_CARD_POLICIES: IPolicies<PROFESSIONAL_CARD_POLICIES_KEYS> = {
  organizationRolesFeatureFlag: {
    name: 'organizationRolesFeatureFlag',
    url: 'global/feature_flag/organization_roles',
    action: 'enable',
  },
  personalInfoEdit: {
    name: 'personalInfoEdit',
    url: 'settings/users/personal_information',
    action: 'edit',
  },
};

export const DEFAULT_PROFESSIONAL_CARD_PERMISSIONS: IPermissions<PROFESSIONAL_CARD_POLICIES_KEYS> = {
  organizationRolesFeatureFlag: false,
  personalInfoEdit: false,
};

export interface ProfessionalCardServiceData {
  labels: GlobalOrganizationsLabel;
  organizationTypeId: ORGANIZATION_TYPE;
  permissions: IPermissions<PROFESSIONAL_CARD_POLICIES_KEYS>;
}

@Injectable()
export class ProfessionalCardService {
  private _data$ = new ReplaySubject<ProfessionalCardServiceData>(1);

  data$ = this._data$.asObservable();

  constructor(private store: Store<any>, private policyPermissionsService: PolicyPermissionsService) {
    this.policyPermissionsService
      .hasMultiplePermissions(Object.values(PROFESSIONAL_CARD_POLICIES))
      .pipe(
        withLatestFrom(this.store.select(LabelSelectors.labels)),
        withLatestFrom(this.store.select(Selectors.organizationTypeId)),
        take(1),
      )
      .subscribe(
        ([[permissions, labels], organizationTypeId]: [
          [IPermissions<PROFESSIONAL_CARD_POLICIES_KEYS>, GlobalOrganizationsLabel],
          ORGANIZATION_TYPE,
        ]) => {
          this._data$.next({
            labels,
            organizationTypeId,
            permissions,
          });
        },
      );
  }
}

@NgModule()
export class ProfessionalCardServiceModule {
  static forRoot(): ModuleWithProviders<ProfessionalCardServiceModule> {
    return {
      ngModule: ProfessionalCardServiceModule,
      providers: [ProfessionalCardService],
    };
  }
}
